import { useLocation, useNavigate } from "react-router-dom";
import { Link as RouterLink } from 'react-router-dom';
import { Box, IconButton, Link, Breadcrumbs } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { MENU_CARD_URL } from "../../../utils/Constants";
import { useMemo } from "react";
import { useRestaurantData } from "../../../provider/RestaurantDataContext";
import SubCategoryDto from "../../../models/SubCategoryDto";
import ItemDto from "../../../models/ItemDto";
import { useTranslation } from "react-i18next";

interface BreadcrumbData {
    path: string;
    itemName: string;
    itemIds: number[];
}

export default function ContextPath() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { restaurantData } = useRestaurantData();
    const basePath = useMemo(() => pathname.substring(0, pathname.indexOf(MENU_CARD_URL) + MENU_CARD_URL.length + 1), [pathname]);
    const elements: BreadcrumbData[] = useMemo(() => {
        const pathTiles: string[] = pathname.substring(pathname.indexOf(MENU_CARD_URL) + MENU_CARD_URL.length + 1).split('/');
        const breadcrumbData: BreadcrumbData[] = [{ itemIds: [], path: '', itemName: t('menu') }];
        const getItemName = (itemIds: number[]) => {
            let item: any;
            if (itemIds.length >= 1) {
                item = restaurantData.categories.filter(cat => cat.id === itemIds[0])[0];
            }
            if (itemIds.length >= 2) {
                item = item.subCategories.filter((sub: SubCategoryDto) => sub.id === itemIds[1])[0];
            }
            if (itemIds.length >= 3) {
                return item = item.items.filter((item: ItemDto) => item.id === itemIds[2])[0].value.value;
            }
            return item.value;
        }
        for (let index = 0; index < pathTiles.length && pathTiles[index].length > 0; index += 2) {
            const itemId = Number.parseInt(pathTiles[index + 1]);
            const combinedPath = (breadcrumbData.length > 0 ? breadcrumbData[breadcrumbData.length - 1].path + '/' : '') + pathTiles[index] + '/' + itemId;
            const itemIds = breadcrumbData.length > 0 ? [...breadcrumbData[breadcrumbData.length - 1].itemIds, itemId] : [itemId];
            breadcrumbData.push({ path: combinedPath, itemName: getItemName(itemIds), itemIds: itemIds });
        }
        return breadcrumbData;
    }, [pathname, restaurantData.categories, t]);
    
    return (
        <>
            {
                <Box style={{ marginTop: '0.8rem', width: '100%' }}>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ color: 'white' }} maxItems={3}>
                        {
                            elements.map((element: BreadcrumbData, index: number) => (
                                <Link key={index} component={RouterLink} underline="hover" to={(basePath + element.path).replace('//', '/')} sx={{ color: index === elements.length - 1 ? 'primary' : 'white' }}>
                                    {element.itemName}
                                </Link>
                            ))
                        }
                    </Breadcrumbs>
                    <IconButton sx={{ pl: '0', pb: '0' }} color='primary' onClick={() => navigate(new Array((elements.length === 3 ? 2 : 1) * 2).fill('../').join(''), { relative: 'path' })}>
                        <ArrowBackIcon />
                    </IconButton>
                </Box>
            }
        </>
    );
}